import { render, staticRenderFns } from "./post-notice.vue?vue&type=template&id=0b7a05ba"
import script from "./post-notice.vue?vue&type=script&lang=ts"
export * from "./post-notice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports